import Vue from 'vue';

const success = response => response.data;

const error = () => {};

export default filter => Vue.$http
    .get('users', { params: filter })
    .then(success)
    .catch(error);



// WEBPACK FOOTER //
// ./src/services/user/get.js